var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 33"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 20",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#12794F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 23",
    cx: 2.5,
    cy: 9.5,
    rx: 2.5,
    ry: 1.5,
    fill: "#12794F"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 26",
    cx: 2.5,
    cy: 16.5,
    r: 2.5,
    fill: "#12794F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 21",
    cx: 9.5,
    cy: 2.5,
    rx: 1.5,
    ry: 2.5,
    fill: "#12794F"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 24",
    cx: 9.5,
    cy: 9.5,
    r: 1.5,
    fill: "#12794F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 27",
    cx: 9.5,
    cy: 16.5,
    rx: 1.5,
    ry: 2.5,
    fill: "#12794F"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 22",
    cx: 16.5,
    cy: 2.5,
    r: 2.5,
    fill: "#12794F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 25",
    cx: 16.5,
    cy: 9.5,
    rx: 2.5,
    ry: 1.5,
    fill: "#12794F"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 28",
    cx: 16.5,
    cy: 16.5,
    r: 2.5,
    fill: "#12794F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApps);
export default __webpack_public_path__ + "static/media/apps.53b3f980f08a4be256bda9851b4514fb.svg";
export { ForwardRef as ReactComponent };